import React, { FC } from "react";
import Blockly from "blockly";
import Storage from "common/BlocklyLesson/utils/Storage";

type Props = {
  userId: number;
};

const KeywordsSettingLink: FC<Props> = ({ userId }) => {
  const storage = new Storage(`${window.location.href}-user${userId}`);

  const saveWorkspace = () => {
    storage.saveWorkspace(Blockly.getMainWorkspace());
  };

  const handleClick = () => {
    saveWorkspace();
    window.location.href = "/keywords";
  };

  return (
    <a
      className="header-button"
      onClick={handleClick}
      style={{ cursor: "pointer", display: "block" }}
    >
      キーワードを設定する
    </a>
  );
};

export default KeywordsSettingLink;
